import React from 'react'
import {
  FormControl,
  FormHelperText,
  InputLabel,
  Select,
  OutlinedInput,
  FilledInput,
  Input,
} from '@material-ui/core'
import * as R from 'ramda'

const Selector = (props) => {
  const {
    shouldShowErrorMsg,
    errorMessage,
    value,
    onChange,
    FormControlProps,
  } = props
  const importedProps = R.pick(
    [
      'autoWidth',
      'children',
      'classes',
      'displayEmpty',
      'input',
      'inputProps',
      'MenuProps',
      'multiple',
      'native',
      'onChange',
      'onClose',
      'onOpen',
      'open',
      'renderValue',
      'SelectDisplayProps',
      'value',
      'variant',
      'disabled',
    ],
    props,
  )

  const variant = importedProps.variant || 'outlined'

  function input() {
    switch (variant) {
      case 'outlined':
        return (
          <OutlinedInput
            labelWidth={R.compose(
              R.multiply(8),
              R.length,
              R.prop('label'),
            )(props)}
            id={props.name}
          />
        )
      case 'filled':
        return <FilledInput id={props.name} />
      default:
        return <Input id={props.name} />
    }
  }

  return (
    <FormControl
      error={shouldShowErrorMsg}
      className={props.className}
      variant={variant}
      required={props.required}
      {...FormControlProps}
    >
      {props.label && (
        <InputLabel htmlFor={props.name}>{props.label}</InputLabel>
      )}
      <Select
        {...importedProps}
        variant={variant}
        value={value}
        onChange={onChange}
        input={input()}
      />
      {shouldShowErrorMsg && <FormHelperText>{errorMessage}</FormHelperText>}
    </FormControl>
  )
}

export default Selector
